import {zImgPath, config, configUrlsJson} from '../config/config';
import {onError} from '../util/util';

var propertyAddress = "";

var createProjectInfoStoreJson = (projectId, getImageListJson) => {
    dojo.xhrGet({
       url: configUrlsJson.projectInfoUrl + projectId,
       headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=utf-8'
       },
       handleAs: "json",
       preventCache: true,
       load: function (resp) {

           propertyAddress = resp.name;
           if(!propertyAddress && resp["address-info"]) {
               propertyAddress = resp["address-info"].line;
           }

           dojo.xhrGet({
                  url: configUrlsJson.imageListUrl + projectId,
                  headers: {
                       'Accept': 'application/json',
                       'Content-Type': 'application/json;charset=utf-8'
                  },
                  handleAs: "json",
                  preventCache: true,
                  load: function (respImgs) {
                      if(respImgs) {
                          var imgData = populateDataFromJson(respImgs);
                          getImageListJson(imgData, resp["customer-info"]);
                      }
                  },
                  error: function(error) {
                      console.error("createProjectInfoStoreJson - imageListUrl: " + error);
                      onError(true);
                  }
              });

       },
       error: function(error) {
           console.error("createProjectInfoStoreJson - projectInfoUrl: " + error);
           onError(true);
       }
   });
};

var populateDataFromJson = (respImgs) => {
    var photoData = [];
    var planData = [];
    var zviewData = [];
    var images = respImgs.images.filter(item => item['sort-index'] >= 0);
    if(images && images.length > 0) {
        images.forEach((img) => {
            var fileFormat = img.small.substring(img.small.lastIndexOf(".") + 1).toLowerCase();
            if(fileFormat == "jpg" || fileFormat == "png") {
                var title = img.title;
                var object = {
                    "thumb": zImgPath + img.small,
                    "large": zImgPath + img.large,
                    "title": title.substring(0, title.lastIndexOf(".")).toLowerCase(),
                    "sortIndex": img["sort-index"]
                };
                var type = img.type.toLowerCase();
                if(type == "floorplan") {
                    object.type = img.type;
                    planData.push(object);
                } else {
                    photoData.push(object);
                }
            }
        });
    }
    if(respImgs.others && respImgs.others.length > 0) {
        respImgs.others.forEach((img) => {
            var type = img.type.toLowerCase();
            if(type == "zview" && img.data) {
                var data = JSON.parse(img.data);
                var {browserUrl} = data.vimeoUrl;
                photoData.push({type: img.type, url: browserUrl, generate: true});
            }
        });
    }
    return {photoData, planData};
};

// *********************************************
// OLD XML logic
var createProjectInfoStore = (projectId, getImageList) => {
    var cfg = config(projectId);
    var projectInfostore = new dojox.data.XmlStore({url: cfg.projectXMLUrl + projectId, rootItem: "project-info"});
    projectInfostore.fetch(
        {
            onComplete: function (projectData) {
                var projectInfo = projectData[0];
                var customerId = projectInfostore.getValue(projectInfo, "customerId") ? projectInfostore.getValue(projectInfo, "customerId") + "" : null;
                if(projectInfo !== undefined && projectInfostore.getValue(projectInfo, "name") !== undefined) {
                    if((projectInfostore.getValue(projectInfo, "name") + "") != "cHome zentuvo") {
                        propertyAddress = projectInfostore.getValue(projectInfo, "name") + "";
                    }
                } else {
                    if(projectInfostore.getValue(projectInfo, "address-info") !== undefined && projectInfostore.getValue(projectInfostore.getValue(projectInfo, "address-info"), "line") !== undefined) {
                        propertyAddress = projectInfostore.getValue(projectInfostore.getValue(projectInfo, "address-info"), "line") + "";
                    }
                }

                var store = new dojox.data.XmlStore({url: cfg.imageListXMLURL, rootItem: "image-list"});
                store.fetch({onComplete: function(imgList) {
                    getImageList(imgList, store, customerId);
                },
                onError: function(error) {
                    console.error(error);
                }});
            },
            onError: function (error) {
                console.error(error);
            }
        }
    );
};

var populateDataFromXmlStore = (store, imageList0) => {
    var photoData = [];
    var planData = [];
    var items = store.getValue(imageList0, "images");
    var images = store.getValues(items, "image");
    for (var i = 0; i < images.length; i++){
        var sortIndex = parseFloat(store.getValue(images[i], "sortIndex"));
        if((store.getValue(images[i], "selected") + "") == "true" && sortIndex >= 0){
            var item = store.getValue(images[i], "links");
            var title = store.getValue(images[i], "title") + "";
            var original = store.getValue(item, "ORIGINAL") + "";
            var fileFormat = original.substring(original.lastIndexOf(".") + 1).toLowerCase();
            if(fileFormat == "jpg" || fileFormat == "png"){
                if((store.getValue(images[i], "image-type") + "") == "Floorplan" ||
                        (store.getValue(images[i], "type") + "") == "floorplan"){

                    var object = {"thumb": zImgPath + store.getValue(item, "ImgCH_126x189"),
                        "large": zImgPath + store.getValue(item, "ImgCH_1100x1100"),
                        "type": "Floorplan",
                        "title": title.substring(0, title.lastIndexOf(".")).toLowerCase(),
                        "sortIndex": sortIndex
                    };
                    if(!(store.getValue(item, "MOBILE_LARGE") === undefined)){
                        object.large = zImgPath + store.getValue(item, "MOBILE_LARGE");
                    }
                    if(!(store.getValue(item, "ImgCH_1600x1600") === undefined)){
                        object.larger = zImgPath + store.getValue(item, "ImgCH_1600x1600");
                    }
                    if(!(store.getValue(item, "CHOME_LARGE") === undefined)){
                        object.larger = zImgPath + store.getValue(item, "CHOME_LARGE");
                    }
                    if(!(store.getValue(item, "CHOME_SMALL") === undefined)){
                        object.thumb = zImgPath + store.getValue(item, "CHOME_SMALL");
                    }
                    planData.push(object);
                } else {
                    var object = {"thumb": zImgPath + store.getValue(item, "ImgCH_126x189"),
                        "large": zImgPath + store.getValue(item, "ImgCH_1100x1100"),
                        "title": title.substring(0, title.lastIndexOf(".")).toLowerCase(),
                        "sortIndex": sortIndex
                    };
                    if(!(store.getValue(item, "MOBILE_LARGE") === undefined)){
                        object.large = zImgPath + store.getValue(item, "MOBILE_LARGE");
                    }
                    if(!(store.getValue(item, "ImgCH_1600x1600") === undefined)){
                        object.larger = zImgPath + store.getValue(item, "ImgCH_1600x1600");
                    }
                    if(!(store.getValue(item, "CHOME_LARGE") === undefined)){
                        object.larger = zImgPath + store.getValue(item, "CHOME_LARGE");
                    }
                    if(!(store.getValue(item, "CHOME_SMALL") === undefined)){
                        object.thumb = zImgPath + store.getValue(item, "CHOME_SMALL");
                    }
                    photoData.push(object);
                }
            }
        }
    }
    return {photoData, planData};
};

export {createProjectInfoStore, createProjectInfoStoreJson, populateDataFromXmlStore, propertyAddress};
